"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RtfSectionProperties = void 0;
var paper_kind_1 = require("../../../../core/model/section/paper-kind");
var section_column_properties_1 = require("../../../../core/model/section/section-column-properties");
var section_properties_1 = require("../../../../core/model/section/section-properties");
var general_section_info_1 = require("./general-section-info");
var margins_info_1 = require("./margins-info");
var page_numbering_info_1 = require("./page-numbering-info");
var line_numbering_properties_1 = require("../../../../core/model/section/line-numbering-properties");
var RtfSectionProperties = (function () {
    function RtfSectionProperties() {
        this.coreProperties = new section_properties_1.SectionProperties();
        this.margins = new margins_info_1.RtfMarginsInfo();
        this.pageNumbering = new page_numbering_info_1.PageNumberingInfo();
        this.generalSectionInfo = new general_section_info_1.RtfGeneralSectionInfo();
        this.lineNumbering = new line_numbering_properties_1.LineNumberingProperties();
        this.restartPageNumbering = false;
        this.drawVerticalSeparator = false;
        this.paperKind = paper_kind_1.PaperKind.A4;
        this.currentColumnIndex = 0;
    }
    RtfSectionProperties.prototype.ensureCurrentColumnExists = function () {
        while (this.coreProperties.columnsInfo.length <= this.currentColumnIndex)
            this.coreProperties.columnsInfo.push(new section_column_properties_1.SectionColumnProperties(1, 1));
    };
    RtfSectionProperties.prototype.setCurrentColumnSpace = function (value) {
        this.ensureCurrentColumnExists();
        this.coreProperties.columnsInfo[this.currentColumnIndex].space = value;
    };
    RtfSectionProperties.prototype.setCurrentColumnWidth = function (value) {
        this.ensureCurrentColumnExists();
        this.coreProperties.columnsInfo[this.currentColumnIndex].width = value;
    };
    RtfSectionProperties.prototype.validatePaperKind = function () {
    };
    RtfSectionProperties.prototype.clone = function () {
        var obj = new RtfSectionProperties();
        obj.copyFrom(this);
        return obj;
    };
    RtfSectionProperties.prototype.copyFrom = function (obj) {
        this.coreProperties = obj.coreProperties.clone();
        this.margins.copyFrom(obj.margins);
        this.pageNumbering.copyFrom(obj.pageNumbering);
        this.generalSectionInfo.copyFrom(obj.generalSectionInfo);
        this.lineNumbering.copyFrom(obj.lineNumbering);
        this.restartPageNumbering = obj.restartPageNumbering;
        this.currentColumnIndex = obj.currentColumnIndex;
        this.drawVerticalSeparator = obj.drawVerticalSeparator;
    };
    return RtfSectionProperties;
}());
exports.RtfSectionProperties = RtfSectionProperties;
